import React from "react";
import cn from "classnames";
import BaseButton from "../BaseButton";

export default function FlatActionButton({
  children,
  disabled,
  bgColor = "transparent",
  bgColorHover = "red-light",
  textColor = "red-light",
  textColorHover = "white",
  inlineStyle = null,
  tabIndex,
  ...other
}) {
  return (
    <BaseButton
      inlineStyle={inlineStyle}
      // TODO:
      // Ryan Florence: Sometimes you have to set some TabIndexes...
      tabIndex={disabled ? -1 : undefined}
      disabled={disabled}
      {...other}
      className={cn(
        disabled && `font-thin`,
        disabled && `text-grey`,
        disabled && `cursor-default`,
        !disabled && `text-${textColor}`,
        !disabled && `hover:text-${textColorHover}`,
        !disabled && `font-thin`,
        !disabled && `bg-${bgColor}`,
        !disabled && `hover:bg-${bgColorHover}`,
        !disabled && `ripple-${bgColorHover}`
      )}
    >
      {children}
    </BaseButton>
  );
}



// WEBPACK FOOTER //
// ./src/FlatActionButton/FlatActionButton.js